import { Markdown } from '../../components/Markdown';
import { PageHeader } from '../../components/PageHeader';
import { useDict } from '../../i18n/dictionary';
import { useLocale } from '../../lib/locale';
import { usePageTitle } from '../../lib/page';
import type { Story } from '../../lib/story';
import { libraryDict } from './i18n';
import { StoryCards } from './StoryCards';
import { storiesOf } from './stories';

const SECTIONS: Story['kind'][] = ['component', 'icons', 'primitives'];

/** Every story, grouped the way the navigation groups them. */
export function LibraryHome() {
  const t = useDict(libraryDict);
  const { locale } = useLocale();
  usePageTitle(t.homeTitle);
  const headings = {
    component: t.components,
    icons: t.icons,
    primitives: t.primitives,
  };

  return (
    <>
      <PageHeader title={t.appName} />
      <div className="form-hint">
        <Markdown>{t.intro}</Markdown>
      </div>
      <div className="library-sections">
        {SECTIONS.map((kind) => (
          <section key={kind}>
            <h2 className="heading-section">{headings[kind]}</h2>
            <StoryCards entries={storiesOf(kind, locale)} />
          </section>
        ))}
      </div>
    </>
  );
}
